const doc = [({"da":({"js":({"admin":({"logs":({"index":({"logs":"Logs"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;